/**
 * Created by sagardesai on 11/07/18.
 */

import React, {Component} from 'react';
import {Field, reduxForm} from "redux-form";
import {connect} from "react-redux";
import * as actions from "../actions/index";
import loading_white from '../assets/gif/loading_white.gif';
import {getData, LOGIN} from "../util/storage";


import {renderTextAreaField} from "../util/account_management";
import {isEmpty, required, vuepayAlert, removeWordFromList} from "../util/utility";
import {getUserProfile} from "../util/business_logic";

class MessageUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            count: 0
        }
        this.toggle = this.toggle.bind(this);
        this.textAreaChange = this.textAreaChange.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps.hasOwnProperty("broadcaster_send_message") &&
            nextProps.broadcaster_send_message.hasOwnProperty("payload") &&
            nextProps.broadcaster_send_message.payload !== null &&
            nextProps.broadcaster_send_message.payload !== undefined) {
            if (nextProps.broadcaster_send_message.payload.hasOwnProperty("success")) {
                vuepayAlert("success", nextProps.broadcaster_send_message.payload.success.message);
                this.setState({count: 0})
                this.props.reset();
            }
            else if (nextProps.broadcaster_send_message.isError) {
                vuepayAlert("error", nextProps.broadcaster_send_message.payload.message);
            }
            this.props.resetSendMessage()


        }
    }

    toggle(_type) {
        this.setState({
            message_to_type: _type
        }, () => {

            const index = (_type === "followers") ? 0 : 1,
                target = document.getElementsByClassName("message_to_type")[index],
                oppositeIndex = (_type === "followers") ? 1 : 0,
                oppositeTarget = document.getElementsByClassName("message_to_type")[oppositeIndex];

            if (target.classList.contains("active")) {
                target.classList.remove("active")
            } else {
                oppositeTarget.classList.remove("active")
                target.classList.add("active")
            }
        })
    }

    /**
     * @function listener for text area change we use this to maintain the count of the characters the user has typed
     * @param e
     */
    textAreaChange(event, newValue, previousValue, name) {
        setTimeout(() => {
            const newData = removeWordFromList(this.props.account_management.userDetails.broadcaster[0].id, this.props.profanity, event.target.value, true, false);
            this.props.dispatch(this.props.change( name, newData));
            this.setState({
                count: newData.length,
            });
        }, 0);
    }

    onSubmit(values) {
        if (values.message && values.message.length < 1) {
            vuepayAlert("error", "Please enter a message");
            return
        }
        var jsonData = {
            message: values.message,
            device: this.props.device
        }
        if (this.props.userData !== null) {
            jsonData = {
                ...jsonData,
                user_id: this.props.userData.user_id,
                type: "user"
            }
        }
        else {
            if (this.state.message_to_type) {
                jsonData = {
                    ...jsonData,
                    type: this.state.message_to_type === "favourites" ? "all_favourites" : "all_followers"
                }
            }
            else {

                if (document.getElementById("message_followers_button").classList.contains("active")) {
                    jsonData = {
                        ...jsonData,
                        type: "all_followers"
                    }
                }
                else if (document.getElementById("message_favourites_button").classList.contains("active")) {
                    jsonData = {
                        ...jsonData,
                        type: "all_favourites"
                    }
                }
                else {
                    vuepayAlert("error", "Please select appropriate group to send message");
                    return
                }


            }

        }

        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.props.sendMessage(data.token, data.api_token, jsonData);
                }
            })

    }

    clickedOnUnblockViewer = () => {

        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.props.unBlockViewer(data.token, data.api_token, this.props.userData.user_id);
                }
            })
    }


    render() {

        const {handleSubmit} = this.props;
        // {this.props.isVisible && this.props.messageAllData && this.props.messageAllData.messageForAllFavourites ? this.toggle("favourites"):this.toggle("followers")}

        return (
            <div className="message-container" id="messageContainer"
                 style={this.props.isVisible ? {display: "block"} : {display: "none"}}>
                <button type="button" onClick={this.props.closeMessage} className="close"><span
                    aria-hidden="true">×</span></button>
                <div className="message-wrapper">

                    {this.props.userData === null && this.props.messageAllData && <div>
                        <h5>Announcement</h5>
                        <button
                            className={`btn btn-outline-primary message_to_type ${this.props.messageAllData === "followers" ? "active" : ""}`}
                            id="message_followers_button" onClick={() => {
                            this.toggle("followers")
                        }}>Followers
                        </button>
                        <button
                            className={`btn btn-outline-primary message_to_type ${this.props.messageAllData === "favourites" ? "active" : ""}`}
                            id="message_favourites_button" onClick={() => {
                            this.toggle("favourites")
                        }}>Favourites
                        </button>


                    </div>}

                    {this.props.userData && <div>
                        <h5>Message User</h5>
                        <div className="followers-img">
                            <img src={getUserProfile(this.props.userData.profile_pic)} alt="followers"/>
                        </div>
                        <p><strong>{this.props.userData.username}</strong></p>
                        {this.props.userData.is_blocked && <p className="small messages">
                            <a href="#"
                               onClick={ev => {
                                   ev.preventDefault();
                                   this.clickedOnUnblockViewer();
                               }}
                               title="Block User">
                                Unblock user
                            </a>
                        </p>}

                    </div>}
                    <div className="form-group">
                        <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                            <Field
                                label=""
                                name="message"
                                maxLength={500}
                                height={"153px"}
                                count={this.state.count}
                                validate={[required]}
                                minLength={1}
                                component={renderTextAreaField}
                                onChange={this.textAreaChange}
                            />
                            <div className="text-right">
                                {
                                    this.props.broadcaster_send_message.isFetching
                                        ?
                                        <button className="btn btn-outline-primary">
                                            <img src={loading_white}
                                                 alt={"Loading"}
                                                 width={26}
                                                 height={26}/></button>
                                        :
                                        <button className="btn btn-outline-primary">Send</button>
                                }

                            </div>
                        </form>
                    </div>


                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        device: state.device.payload,
        account_management: state.account_management,
        profanity: state.profanity.words,
        broadcaster_send_message: state.broadcaster_send_message,
        broadcaster_block_unblock_viewer: state.broadcaster_block_unblock_viewer,
        initialValues: {
            message: ""
        }
    };
}

export default reduxForm({
    form: 'MessageForm'
})(
    connect(mapStateToProps, actions)(MessageUser)
);
